<script setup lang="ts">
/*
* Компонент CustomDivider - кастомный разделитель с опциональным заголовком
*
* Основные функции:
* - Визуальное разделение контента на секции
* - Отображение опционального заголовка в центре разделителя
* - Адаптивная ширина с возможностью ограничения максимальной ширины
*
* Особенности реализации:
* - Гибкая настройка максимальной ширины через props
* - Автоматическое преобразование заголовка в верхний регистр
* - Симметричное расположение линий относительно текста
* - Чистая визуальная реализация без сложной логики
*/

// Определение props компонента
defineProps<{
  title?: string // Опциональный заголовок для отображения в центре разделителя
  maxWidth?: string // Максимальная ширина компонента (например: '100%', '500px', '80vw')
}>()
</script>

<template>
  <div
    class="custom-divider"
    :style="maxWidth ? { maxWidth } : {}"
  >
    <span v-if="title" class="line left" />
    <span v-if="title" class="text body-2">{{ title.toUpperCase() }}</span>
    <span class="line right" />
  </div>
</template>

<style lang="scss">
.custom-divider {
  display: flex;
  align-items: center;
}

.custom-divider .line {
  height: 1px;
  background-color: rgb(var(--v-theme-text-primary), var(--v-custom-opacity));
  flex-shrink: 0;
}

.custom-divider .line.left {
  width: 0.875rem;
}

.custom-divider .line.right {
  flex: 1;
}

.custom-divider .text {
  color: rgb(var(--v-theme-text-primary), var(--v-disabled-opacity));
  white-space: nowrap;
  margin: 0.5625rem;
}
</style>
